module.exports = __webpack_public_path__ + "media/images/projet_01-19de27fa623b6c25f89546a82d8c8ecc.jpg";